var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cb6c69;}.b{fill:#c1b5d2;}.c{fill:#fbc933;}.d{fill:#ad5cad;}.e{fill:#e9893a;}.f{fill:#bfbf3a;}.g{fill:#fff;font-size:3px;font-family:SegoeUI, Segoe UI;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 474) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H50V25H0Z",
    transform: "translate(45 424)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13,
    height: 25,
    transform: "translate(82 449)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 19,
    height: 12,
    transform: "translate(45 449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H19V13H0Z",
    transform: "translate(45 461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0H19V12H0Z",
    transform: "translate(64 449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0H19V13H0Z",
    transform: "translate(64 461)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(82 435) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(79 467) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(60 454) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(92 460) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(77 454) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(58 467) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom4);
export default __webpack_public_path__ + "static/media/random4.3b6e836f9a18df60ead8427b93c6f552.svg";
export { ForwardRef as ReactComponent };